import type { FormEvent } from "react";
import { ApiError } from "./api";

/** Reads a submitted form into a plain string map (and prevents the browser submit). */
export function formValues(e: FormEvent<HTMLFormElement>): Record<string, string> {
  e.preventDefault();
  return Object.fromEntries(new FormData(e.currentTarget)) as Record<string, string>;
}

/** Field-level messages from a validation error, or none for other failures. */
export function fieldErrors(err: unknown): Record<string, string> {
  return err instanceof ApiError ? err.fieldErrors() : {};
}

export const hasFieldErrors = (err: unknown) => Object.keys(fieldErrors(err)).length > 0;
